import React from "react";

interface TButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isActive?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const Spinner: React.FC<{ className?: string }> = ({ className = "" }) => (
  <svg
    className={`animate-spin h-5 w-5 ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const TButton: React.FC<TButtonProps> = ({
  children,
  className = "",
  style,
  isDisabled,
  isActive = false,
  isLoading = false,
  ...rest
}) => {
  const defaultClasses =
  "text-black px-5 py-4 uppercase rounded-full border border-black " +
  "disabled:bg-[#182E5E] disabled:opacity-60 disabled:cursor-not-allowed";
  const activeClasses = "bg-[#182E5E] text-white font-[400] text-[14px]";
  const combinedClasses = `${defaultClasses} ${
    isActive ? activeClasses : ""
  } ${className}`.trim();

  return (
    <button
      className={combinedClasses}
      style={style}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {isLoading ? (
        <span className="flex items-center justify-center gap-2">
          <Spinner />
          <span>Loading...</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default TButton;
